module.exports = __webpack_public_path__ + "img/doc-lock-icon.f20abec5.svg";